import { z } from 'zod';

// Reusable validation rules
export const ValidationRules = {
  // String validations
  required: z.string().min(1, 'This field is required'),
  optional: z.string().optional(),

  // Email validation
  email: z.string().email('Invalid email format').min(1, 'Email is required'),

  // Username validation
  username: z.string().trim().min(1, 'Username is required'),

  // Password validation
  password: z.string().min(1, 'Password is required'),

  // Pairing code validation (8 characters, alphanumeric)
  pairingCode: z
    .string()
    .length(8, 'Pairing code must be exactly 8 characters'),

  // Array of pairing code characters
  pairingCodeArray: z
    .array(z.string().length(1))
    .length(8, 'Pairing code must be 8 characters'),

  // OTP validation (6 digits)
  otp: z.array(z.string().length(1)).length(6, 'Code must be 6 digits'),
} as const;
